import AddressBookRoute from './AddressBookRoute'
import ShippingInfoPrefRoute from './ShippingInfoPrefRoute'
import BookingPrefRoute from './BookingPrefRoute'

const routes = [new ShippingInfoPrefRoute(), new AddressBookRoute(), new BookingPrefRoute()]

export default routes
